import styles from "./sidemenu.module.scss";
import SidemenuLink from "./sidemenu_link";
import { SidemenuItem } from "./../../store";
import SidebarTooltip from "./sidebar_tooltip";

export default function SideMenu({
  isToggled,
  menuItems,
}: {
  isToggled: boolean;
  menuItems: SidemenuItem[];
}) {
  const renderMenuItem = (sidemenu: SidemenuItem) => {
    const menuItem = (
      <li key={sidemenu.title}>
        <SidemenuLink
          label={sidemenu.title}
          href={sidemenu.href}
          icon={sidemenu.icon}
          isToggled={isToggled}
          activeMatch={sidemenu.activeMatch}
          activeMatchState={sidemenu.activeMatchState}
          dataQa={sidemenu.dataQa}
        />
      </li>
    );

    // Only wrap with tooltip when sidebar is collapsed (isToggled = true)
    if (isToggled) {
      return (
        <SidebarTooltip
          title={sidemenu.title}
          key={sidemenu.title}
          placement="right"
        >
          {menuItem}
        </SidebarTooltip>
      );
    }

    return menuItem;
  };

  return (
    <div className={styles.sidemenu_wrapper} data-qa="side-menu-links">
      <ul>{menuItems.map(renderMenuItem)}</ul>
    </div>
  );
}
